/* Prestige Wear — Offre « 3ème produit offert » + compte à rebours
   - Pop-up après X secondes, compte à rebours rouge de N minutes
   - Fermée : le compte à rebours reste visible dans une barre en haut
   - Pendant le compte à rebours, le code Shopify "Achetez 2, obtenez 1" est
     appliqué au panier → le 3ème article passe à 0 € (panier + paiement)
   - À 00:00 : le code est retiré, plus rien ne s'affiche tant que la visite dure
   - Mode "session" : l'offre repart à zéro quand l'onglet est fermé puis rouvert
     Mode "once"    : une seule fois par visiteur */
(function(){
  'use strict';
  var cfgEl=document.getElementById('pwOfferConfig');
  if(!cfgEl)return;
  var cfg;try{cfg=JSON.parse(cfgEl.textContent);}catch(e){return;}

  var KEY='pw_offer_v1';
  var DUR=Math.max(1,cfg.minutes)*60000;
  var store=(function(){
    try{var s=cfg.mode==='once'?window.localStorage:window.sessionStorage;s.setItem('__pw','1');s.removeItem('__pw');return s;}
    catch(e){var m={};return{getItem:function(k){return m[k]||null;},setItem:function(k,v){m[k]=v;}};}
  })();
  function load(){try{return JSON.parse(store.getItem(KEY));}catch(e){return null;}}
  function save(s){try{store.setItem(KEY,JSON.stringify(s));}catch(e){}}

  var modal=document.getElementById('pwOfferModal');
  var bar=document.getElementById('pwOfferBar');
  var card=modal&&modal.querySelector('.pw-modal__card');
  var state=load();
  var ticker=null,lastFocus=null;

  /* ---------- Code de réduction Shopify ---------- */
  function post(url,body){
    return fetch(url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json();});
  }
  function getCart(){return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();});}
  function currentCodes(cart){
    return ((cart&&cart.discount_codes)||[]).map(function(d){return d.code;}).filter(Boolean);
  }
  function applyCode(){
    if(!cfg.code)return Promise.resolve();
    return getCart().then(function(cart){
      var codes=currentCodes(cart);
      if(codes.map(function(c){return c.toUpperCase();}).indexOf(cfg.code.toUpperCase())===-1)codes.push(cfg.code);
      return post('/cart/update.js',{discount:codes.join(',')});
    }).catch(function(){})
      /* Filet de sécurité : cookie de réduction Shopify, lu aussi au paiement */
      .then(function(){return fetch('/discount/'+encodeURIComponent(cfg.code)+'?redirect=%2Fcart.js',{credentials:'same-origin'});})
      .catch(function(){});
  }
  function removeCode(){
    if(!cfg.code)return Promise.resolve();
    document.cookie='discount_code=; Max-Age=0; path=/';
    return getCart().then(function(cart){
      var codes=currentCodes(cart).filter(function(c){return c.toUpperCase()!==cfg.code.toUpperCase();});
      return post('/cart/update.js',{discount:codes.join(',')});
    }).catch(function(){});
  }

  /* ---------- Affichage ---------- */
  function pad(n){return (n<10?'0':'')+n;}
  function remaining(){return state?Math.max(0,state.start+DUR-Date.now()):0;}
  function render(){
    var ms=remaining(),t=Math.ceil(ms/1000),m=Math.floor(t/60),s=t%60;
    var txt=pad(m)+':'+pad(s);
    document.querySelectorAll('[data-pw-timer]').forEach(function(el){el.textContent=txt;});
    document.querySelectorAll('[data-pw-mm]').forEach(function(el){el.textContent=pad(m);});
    document.querySelectorAll('[data-pw-ss]').forEach(function(el){el.textContent=pad(s);});
    if(modal)modal.classList.toggle('is-urgent',t<=60);
    if(ms<=0)expire();
  }
  function startTicker(){render();if(!ticker)ticker=setInterval(render,1000);}

  function showBar(){
    if(!bar)return;
    bar.hidden=false;
    requestAnimationFrame(function(){
      bar.classList.add('is-visible');
      document.documentElement.style.setProperty('--pw-bar-h',bar.offsetHeight+'px');
      document.body.classList.add('pw-bar-on');
    });
  }
  function hideBar(){
    if(!bar)return;
    bar.classList.remove('is-visible');bar.hidden=true;
    document.body.classList.remove('pw-bar-on');
    document.documentElement.style.setProperty('--pw-bar-h','0px');
  }

  function openModal(){
    if(!modal||!state||state.status!=='active')return;
    lastFocus=document.activeElement;
    hideBar();
    modal.hidden=false;
    document.body.classList.add('pw-modal-open');
    refreshCart();
    requestAnimationFrame(function(){requestAnimationFrame(function(){modal.classList.add('is-open');card&&card.focus();});});
  }
  function closeModal(){
    if(!modal||modal.hidden)return;
    modal.classList.remove('is-open');
    document.body.classList.remove('pw-modal-open');
    setTimeout(function(){modal.hidden=true;},300);
    if(state&&state.status==='active'){
      state.seen=true;save(state);showBar();
      if(cfg.isCart&&state.needsCartReload){state.needsCartReload=false;save(state);location.reload();return;}
    }
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }

  function refreshCart(){
    getCart().then(function(cart){
      var n=cart.item_count||0;
      document.querySelectorAll('[data-pw-slot]').forEach(function(el){
        el.classList.toggle('is-done',n>=parseInt(el.getAttribute('data-pw-slot'),10));
      });
      var st=document.querySelector('[data-pw-status]');
      if(st){
        st.textContent=n>=3?'C\u2019est gagné : le 3ème article est à 0 € dans votre panier.'
          :n===2?'Plus qu\u2019un article et il est offert.'
          :n===1?'Encore 2 articles : le 3ème passe à 0 €.'
          :'Ajoutez 3 articles au panier : le 3ème passe à 0 €.';
      }
      var link=document.querySelector('[data-pw-cartlink]');
      if(link)link.hidden=n===0;
    }).catch(function(){});
  }

  /* ---------- Panier : garantit que la remise est bien appliquée ----------
     Si le code vient d'être (ré)appliqué et que la remise calculée par Shopify
     diffère de celle affichée, on recharge une fois la page panier. */
  function syncCart(){
    return applyCode().then(getCart).then(function(cart){
      var el=document.getElementById('pwCartOffer');
      var codes=(cart.discount_codes||[]);
      var ours=codes.filter(function(d){return (d.code||'').toUpperCase()===(cfg.code||'').toUpperCase();})[0];
      if(cart.item_count>=3&&(!ours||ours.applicable===false)){
        console.warn('[Prestige Wear] Le code "'+cfg.code+'" n\u2019est pas accepté par Shopify : vérifiez qu\u2019il existe dans Remises (Achetez 2, obtenez 1), qu\u2019il est actif et couvre tous les produits.');
      }
      if(!cfg.isCart||!el)return;
      var shown=parseInt(el.getAttribute('data-discount')||'0',10);
      var sig=cart.item_count+'|'+cart.total_discount;
      var last=null;try{last=sessionStorage.getItem('pw_sync_sig');}catch(e){}
      if(cart.total_discount!==shown&&last!==sig){
        try{sessionStorage.setItem('pw_sync_sig',sig);}catch(e){}
        location.reload();
      }
    }).catch(function(){});
  }

  /* ---------- Cycle de vie ---------- */
  function begin(){
    state={start:Date.now(),status:'active',needsCartReload:!!cfg.isCart};
    save(state);
    applyCode();
    startTicker();
    openModal();
  }
  function expire(){
    if(ticker){clearInterval(ticker);ticker=null;}
    if(!state||state.status==='expired')return;
    state.status='expired';save(state);
    if(modal){modal.classList.remove('is-open');modal.hidden=true;document.body.classList.remove('pw-modal-open');}
    hideBar();
    var cartEl=document.getElementById('pwCartOffer');if(cartEl)cartEl.hidden=true;
    removeCode().then(function(){if(cfg.isCart)location.reload();});
  }

  /* ---------- Événements ---------- */
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-pw-close]')){e.preventDefault();closeModal();return;}
    if(e.target.closest('[data-pw-open]')){e.preventDefault();openModal();}
  });
  document.addEventListener('keydown',function(e){
    if(!modal||modal.hidden)return;
    if(e.key==='Escape'){closeModal();return;}
    if(e.key==='Tab'&&card){
      var f=card.querySelectorAll('a[href]:not([hidden]),button:not([disabled])');
      if(!f.length)return;
      var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    }
  });
  /* Retour sur l'onglet (mobile en arrière-plan) : recalcule tout de suite */
  document.addEventListener('visibilitychange',function(){if(!document.hidden&&state&&state.status==='active')render();});
  window.addEventListener('pageshow',function(e){if(e.persisted&&state&&state.status==='active')render();});

  function init(){
    if(!state){
      setTimeout(function(){if(!load())begin();},Math.max(0,cfg.delay)*1000);
      return;
    }
    if(state.status==='active'){
      if(remaining()<=0){expire();return;}
      syncCart();                        /* s'assure que le code est toujours là */
      startTicker();
      if(state.seen){showBar();}else{openModal();}
      var cartEl=document.getElementById('pwCartOffer');if(cartEl)cartEl.hidden=false;
      return;
    }
    /* expiré : on garantit que le code n'est plus dans le panier, et on n'affiche rien */
    if(!state.cleaned){state.cleaned=true;save(state);removeCode();}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
